module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/caec35551d9e53178bee24bbd190f8b6.png";